module.exports = {"__schema":{"types":[{"kind":"INTERFACE","name":"ChurchMemberPersonalMultiDayStatistics","possibleTypes":[{"name":"ChurchMemberPersonalAllTimeStatistics"},{"name":"ChurchMemberPersonalWeeklyStatistics"}]}]}}


//////////////////
// WEBPACK FOOTER
// ./src/fragmentTypes.json
// module id = 725
// module chunks = 0